import { observer } from "mobx-react";
import * as React from "react";

import { ListVehicleDevices } from "../ui/molecules/list-vehicle-devices";
import { ListCommandButtonsVehicleDevices } from "../ui/organisms/list-command-buttons-vehicle-devices";
import { createUuid } from "../utils/uuid";
import { Section } from "../ui/atoms/section";
import sizes from "../ui/sizes.scss";
import { store } from "../store";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PageVehicleDevices extends React.Component {
    // Create the UUID on this level, so the button bar is able to access the same state as the list.
    private listStateId = createUuid();

    public render(): JSX.Element {
        return (
            <FusionLayout breadcrumb={store.i18n.t("page.vehicleDevices.title")} classic>
                <Section fill>
                    <ListVehicleDevices
                        commandBar={
                            <ListCommandButtonsVehicleDevices
                                listStateId={this.listStateId}
                                canDelete
                            />
                        }
                        listStateId={this.listStateId}
                        maxHeight={`${sizes.listMaxHeight}`}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
